import { defineComponent as C, computed as t, ref as z, onMounted as g, openBlock as s, createElementBlock as _, normalizeClass as w, createElementVNode as i, normalizeStyle as B, createBlock as b, createCommentVNode as f, renderSlot as V } from "vue";
import v from "./index60.js";
const S = ["aria-checked", "aria-disabled"], $ = { class: "flex items-center justify-center" }, E = ["checked", "disabled", "indeterminate"], D = /* @__PURE__ */ C({
  __name: "BaseCheckbox",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    size: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(p, { emit: k }) {
    const a = p, d = k, r = t(() => a.modelValue), o = t(() => a.disabled), l = t(() => a.indeterminate), h = t(() => {
      const e = {};
      return e.width = `${c[a.size]}`, e.height = `${c[a.size]}`, o.value ? r.value ? (e.backgroundColor = "var(--base-colors-neutral-neutral400)", e.borderColor = "var(--base-colors-neutral-neutral400)") : (e.backgroundColor = "var(--base-colors-neutral-neutral300)", e.borderColor = "var(--base-colors-neutral-neutral400)") : r.value || l.value ? (e.backgroundColor = "var(--base-colors-primary-primary800)", e.borderColor = "var(--base-colors-primary-primary800)") : (e.backgroundColor = "var(--input-check-radio-active-bg)", e.borderColor = "var(--base-colors-neutral-neutral400)"), e;
    }), c = {
      sm: "var(--base-size-size-16)",
      md: "var(--base-size-size-18)",
      lg: "var(--base-size-size-20)"
    };
    t(() => ({
      flexShrink: "0",
      boxSizing: "border-box"
    }));
    const u = () => {
      o.value || d("update:modelValue", !r.value);
    }, y = (e) => {
      (e.key === "Enter" || e.key === " ") && (e.preventDefault(), u());
    }, n = z();
    return g(() => {
      n.value && (n.value.indeterminate = a.indeterminate);
    }), (e, m) => (s(), _("div", {
      class: w(["inline-flex min-w-fit flex-shrink-0 cursor-pointer select-none items-center gap-1 align-top leading-none", { "cursor-not-allowed": o.value }]),
      onClick: u,
      onKeydown: y,
      tabindex: "0",
      role: "checkbox",
      "aria-checked": l.value ? "mixed" : r.value ? "true" : "false",
      "aria-disabled": o.value
    }, [
      i("div", $, [
        i("div", {
          class: "box-border flex h-full w-full items-center justify-center rounded-[3px] border border-[1.5px]",
          style: B(h.value)
        }, [
          r.value && !l.value ? (s(), b(v, {
            key: 0,
            name: "check-sm",
            color: "white"
          })) : f("", !0),
          l.value ? (s(), b(v, {
            key: 1,
            name: "minus",
            color: "white"
          })) : f("", !0)
        ], 4)
      ]),
      i("input", {
        type: "checkbox",
        class: "sr-only",
        checked: r.value,
        disabled: o.value,
        indeterminate: l.value,
        onChange: m[0] || (m[0] = (x) => d("update:modelValue", x.target.checked)),
        ref_key: "hiddenInput",
        ref: n
      }, null, 40, E),
      V(e.$slots, "default")
    ], 42, S));
  }
});
export {
  D as default
};
